<template>
	<o-section
		v-if="api"
		:title="$t('common.shared.tour.annotations.title')">
		<o-textarea
			v-model="setup.annotation"
			autofocus
			:label="$t('common.shared.forms.enterAnnotation')"
			@submit="setup.saveAnnotationAsync()"/>

		<o-section
			class="mt-md"
			align="stretch">
			<o-button
				color="danger"
				outline
				@click="_modal?.close()">
				{{ $t('common.shared.actions.close') }}
			</o-button>
			<o-button
				color="info"
				prefix-icon="check"
				@click="setup.saveAnnotationAsync()">
				{{ $t('common.shared.actions.save') }}
			</o-button>
		</o-section>
	</o-section>
</template>

<script setup lang="ts">
import { inject } from 'vue';
// #region Setup
import type { SharedAnnotationEmits, SharedAnnotationProps } from './SharedAnnotationSetup';
import SharedAnnotationSetup from './SharedAnnotationSetup';
const emits = defineEmits<SharedAnnotationEmits>() as SharedAnnotationEmits;
const props = withDefaults(defineProps<SharedAnnotationProps>(), SharedAnnotationSetup.defaultProps);
const _modal = inject<OrionModal>('_modal');
const setup = new SharedAnnotationSetup(props, emits, _modal);
// #endregion
</script>
